import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Library from './pages/library/Library';
import MakeDetail from './pages/library/MakeDetail';
import ModelDetail from './pages/library/ModelDetail';
import Parts from './pages/library/Parts';
import LibraryRequests from './pages/libraryRequests/LibraryRequests';
import Customers from './pages/customers/Customers';
import CustomerDetail from './pages/customers/CustomerDetail';
import OpsMachineProfile from './pages/customers/OpsMachineProfile';
import Settings from './pages/settings/Settings';
import Contracts from './pages/contracts/Contracts';
import NewContract from './pages/contracts/NewContract';
import ContractDetail from './pages/contracts/ContractDetail';
import Sign from './pages/sign/Sign';
import Pay from './pages/pay/Pay';
import Yard from './pages/yard/Yard';
import Projects from './pages/projects/Projects';
import ProjectDetail from './pages/projects/ProjectDetail';
import CompanyDetails from './pages/packs/CompanyDetails';
import Templates from './pages/packs/Templates';
import Packs from './pages/packs/Packs';
import PackDetail from './pages/packs/PackDetail';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
          <Route path="/library/makes/:makeId" element={<ProtectedRoute><MakeDetail /></ProtectedRoute>} />
          <Route path="/library/makes/:makeId/models/:modelId" element={<ProtectedRoute><ModelDetail /></ProtectedRoute>} />
          <Route path="/library/parts" element={<ProtectedRoute><Parts /></ProtectedRoute>} />
          <Route path="/library/requests" element={<ProtectedRoute><LibraryRequests /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
          <Route path="/customers/ops/:orgId" element={<ProtectedRoute><CustomerDetail /></ProtectedRoute>} />
          <Route path="/customers/ops/:orgId/machines/:machineId" element={<ProtectedRoute><OpsMachineProfile /></ProtectedRoute>} />
          <Route path="/contracts" element={<ProtectedRoute><Contracts /></ProtectedRoute>} />
          <Route path="/contracts/new" element={<ProtectedRoute><NewContract /></ProtectedRoute>} />
          <Route path="/contracts/:contractId" element={<ProtectedRoute><ContractDetail /></ProtectedRoute>} />
          <Route path="/sign" element={<Sign />} />
          <Route path="/sign/:token" element={<Sign />} />
          <Route path="/pay" element={<Pay />} />
          <Route path="/pay/complete" element={<Pay />} />
          <Route path="/pay/:token" element={<Pay />} />
          <Route path="/yard" element={<Yard />} />
          <Route path="/yard/:token" element={<Yard />} />
          <Route path="/company" element={<ProtectedRoute><CompanyDetails /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
          <Route path="/packs" element={<ProtectedRoute><Packs /></ProtectedRoute>} />
          <Route path="/packs/:packId" element={<ProtectedRoute><PackDetail /></ProtectedRoute>} />
          <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
          <Route path="/projects/:projectId" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
